var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "image-settings" } }, [
    _c("div", { staticClass: "form-field" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "image-input" } },
        [_vm._v(_vm._s(_vm.$t("form.image")))]
      ),
      _vm._v(" "),
      _c("input", {
        staticClass: "form-input",
        attrs: { type: "file", id: "image-input" },
        on: { change: _vm.uploadFile },
      }),
      _vm._v(" "),
      _vm.logo
        ? _c("div", [
            _c("img", {
              staticStyle: { "max-width": "100%", "margin-top": "10px" },
              attrs: { src: _vm.logo, alt: "Selected Image" },
            }),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.size"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "size-settings" }, [
        _c("div", { staticClass: "size-input" }, [
          _c("label", { attrs: { for: "width-input" } }, [
            _vm._v(_vm._s(_vm.$t("form.width"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "input-with-unit" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.imageWidth,
                  expression: "imageWidth",
                },
              ],
              staticClass: "form-input",
              attrs: { type: "number", id: "width-input" },
              domProps: { value: _vm.imageWidth },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.imageWidth = $event.target.value
                  },
                  function ($event) {
                    return _vm.updateImageWidth(_vm.imageWidth)
                  },
                ],
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "unit" }, [_vm._v("PX")]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "size-input" }, [
          _c("label", { attrs: { for: "height-input" } }, [
            _vm._v(_vm._s(_vm.$t("form.height"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "input-with-unit" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.imageHeight,
                  expression: "imageHeight",
                },
              ],
              staticClass: "form-input",
              attrs: { type: "number", id: "height-input" },
              domProps: { value: _vm.imageHeight },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.imageHeight = $event.target.value
                  },
                  _vm.updateImageHeight,
                ],
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "unit" }, [_vm._v("PX")]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.imageAlignment"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "button-group" }, [
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.imageAlign === "left" },
            on: {
              click: function ($event) {
                return _vm.updateImageAlign("left")
              },
            },
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("form.left")) +
                "\n            "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.imageAlign === "center" },
            on: {
              click: function ($event) {
                return _vm.updateImageAlign("center")
              },
            },
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("tables.center")) +
                "\n            "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.imageAlign === "right" },
            on: {
              click: function ($event) {
                return _vm.updateImageAlign("right")
              },
            },
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("form.right")) +
                "\n            "
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }